<template>
  <div class="help">
    <van-nav-bar
      title="帮助与反馈"
      left-arrow
      right-text="历史反馈"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />

    <div class="question">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item :title="item.title" :name="index" v-for="(item,index) in question" :key=index><div v-html="item.answer"/></van-collapse-item>
      </van-collapse>
    </div>
    <div class="feedback" @click="toFeedback">意见反馈</div>
    <div class="submits">
      <van-button type="primary" @click="toCustomer">咨询客服</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Collapse, CollapseItem, Button } from 'vant'
Vue.use(Collapse).use(CollapseItem).use(NavBar).use(Button)

export default {
  data() {
    return {
      question: [
        {
          title: '如何打开游戏/应用设备号权限？',
          answer: '①通用流程：设置--应用设置--权限管理，打开对应手机识别码或者IMEI权限。<br/>②部分手机无法使用通用流程请自行百度符合自身机型的操作。'
        },
        {
          title: '游戏数据有误类问题',
          answer: '游戏内红包兑换；游戏激活码、礼包、兑换码问题；这些问题请联系游戏内客服查询，这边是任务页面的客服哈。'
        },
        {
          title: '什么是累计赢取？',
          answer: '累计赢取不是游戏内的赢取，是在游戏要求范围内的净赢取，要扣除成本。如捕鱼游戏里面的赢取是打到的鱼的总金币价值，任务页面上是要扣除打出去的炮的成本。'
        },
        {
          title: '完成任务的奖励发放到哪里？',
          answer: '高额任务奖励：您刷新任务页面达到任务要求后，手动领取奖励由系统自动发放到您下载该游戏的平台账户余额上；兼职任务奖励：在首页-百元躺赚里可看视频获得红包券（红包券余额显示也是在百元躺赚里面哦）；'
        },
        {
          title: '游戏无法登录、闪退',
          answer: '切换网络或者卸载重装试试，有时候网络不稳定是会出现这个情况。游戏进不去，切换网络、卸载重装、清缓存、重启手机，应该能解决大部分问题。若还是不行，请提供您的机型截图联系游戏中的客服反馈。'
        },
        {
          title: '游戏内购买的金币、月卡、钻石有疑义',
          answer: '这个问题请联系游戏内客服查询，这边是任务页面的客服哈。'
        },
        {
          title: '商家的所有手游达到一定战力后任务界面数据突然变0？',
          answer: '该商家所有游戏达到一定战力需要商家审核后才会显示，请您选择数据显示异常提交问题等待客服回复结果。'
        },
        {
          title: '签到第一天奖励没到账？',
          answer: '签到第一天奖励的1.5元是奖励卡哦，您在首页-我的卡券里面可以查看；如完成签到加成任务可额外获得0.5元微信红包；奖励卡是用于任务奖励加成的哦，您做任务的时候会自动使用；比如，任务本来奖励为1元，奖励卡面值0.3元，您做完任务可得1.3元。'
        },
        {
          title: '账号问题',
          answer: '①注销账号<br>我们APP是默认游客登录，账号随机分配；无需注册或者注销（也无需登录或者退出）。<br>②微信号解绑<br>微信无法解绑和换绑，微信只是绑定用于提现的（系统后台未保存微信号），不做其他用途的。<br>③手机号解绑<br>【我的】页面下滑至最底层有一栏【手机号】点开可绑定或更换手机号；注意：为了保障账户安全，更换手机号需要原绑定手机接收验证码。如绑定手机号无法收取验证码，请联系平台内人工客服处理。'
        },
      ],
      activeName: 0
    }
  },
  methods: {
    callClienFunc: function(fname, fval) {
      if (window.hasOwnProperty('injectedObject')) {
        window.injectedObject.setJsContent(fname, fval)
      } else {
        fval = fval? fval : {}
        let params = {method: fname, params:fval}
        params = JSON.stringify(params)
        window.Android.postMessage(params)
      }
    },
    toFeedback: function() {
      this.$router.push({path: '/feedback'})
    },
    toCustomer: function() {
      window.location.href = 'lezhuan://jump?type=48&content={"source":"0"}'
    },
    onClickLeft: function () {
      this.callClienFunc("closeWebview", "")
    },
    onClickRight: function() {
      this.$router.push({path: '/feedback/record'})
    }
  }
}
</script>

<style lang="less" scoped>
  .help {
    display: block;
    width: 100%;
    max-width: 3.75rem;
    min-height: 100vh;
    overflow: hidden;

    .question {
      display: block;
      width: 100%;
      overflow: hidden;
    }
    .feedback {
      display: flex;
      margin: 0 auto;
      margin-top: .15rem;
      margin-bottom: .7rem;
      width: .95rem;
      height: .2rem;
      line-height: .2rem;
      font-size: 16px;
      align-items: center;
      color: #333333;
      overflow: hidden;
    }
    .feedback::before {
      display: inline-block;
      content: ' ';
      width: .2rem;
      height: .2rem;
      background: url('~@/assets/images/feedback.png') no-repeat;
      background-size: .2rem;
      margin-right: .08rem;
      overflow: hidden;
    }
    .submits {
      display: block;
      width: 3.75rem;
      height: .48rem;
      position: fixed;
      bottom: .16rem;
      margin: 0 auto;
      overflow: hidden;

      button {
        display: block;
        background: #FF7F4B;
        border: 1px solid #FF7F4B;
        width: 3.45rem;
        height: .48rem;
        margin: 0 auto;
      }
    }

    /deep/ .van-nav-bar{
      margin-top: .26rem;
    }
    /deep/.van-icon {
      color: #666666;
    }
    /deep/.van-nav-bar__title {
      font-size: 18px;
      color: #333333;
    }
  }
</style>